var $d97dea7aa6bdcba0$exports = {};
$d97dea7aa6bdcba0$exports = {
    "colorFormat": `Kr\u{101}su form\u{101}ts`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$d97dea7aa6bdcba0$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
